module.exports = __webpack_public_path__ + "static/img/位图2.69cb0ccd.png";